import { render, staticRenderFns } from "./EndpointAction.vue?vue&type=template&id=3f618fd3&"
import script from "./EndpointAction.vue?vue&type=script&lang=js&"
export * from "./EndpointAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f618fd3')) {
      api.createRecord('3f618fd3', component.options)
    } else {
      api.reload('3f618fd3', component.options)
    }
    module.hot.accept("./EndpointAction.vue?vue&type=template&id=3f618fd3&", function () {
      api.rerender('3f618fd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/skyQuery/EndpointAction.vue"
export default component.exports